import { gql, TypedDocumentNode } from '@apollo/client';

export type CreatePayPalPaymentMethodMutationShippingAddress = {
  recipientName: string;
  line1: string;
  city: string;
  state: string;
  postalCode: string;
  countryCode: string;
};

export type CreatePayPalPaymentMethodMutationInput = {
  data: {
    nonce: string;
    email: string;
    first_name: string;
    last_name: string;
    payerID: string;
    shipping_address: CreatePayPalPaymentMethodMutationShippingAddress;
    currency: string;
  };
};

export type CreatePayPalPaymentMethodMutationVariables = {
  input: CreatePayPalPaymentMethodMutationInput;
};

export type CreatePayPalPaymentMethodMutation = {
  createPayPalPaymentMethod: {
    __typename: 'RestCreatePayPalPaymentMethod';
    success: boolean;
    guestAccessToken: string | null;
    email: string;
    isMember: boolean | null;
  };
};

export const CREATE_PAYPAL_PAYMENT_METHOD_MUTATION: TypedDocumentNode<
  CreatePayPalPaymentMethodMutation,
  CreatePayPalPaymentMethodMutationVariables
> = gql`
  mutation CreatePayPalPaymentMethodMutation($input: CreatePayPalPaymentMethodMutationInput) {
    createPayPalPaymentMethod(input: $input)
      @rest(
        type: "RestCreatePayPalPaymentMethod"
        endpoint: "cart"
        path: "/v3.3/paypal/process_payment"
        method: "POST"
      ) {
      success
      guestAccessToken: guest_access_token
      email: email
      isMember: is_member
    }
  }
`;
